// extracted by mini-css-extract-plugin
export default {"root":"AddOnPanel_root__a6JvK"};